export enum HiddenLayerFunctionality {
  featureInfo = 'feature-info',
  attributeList = 'attribute-list',
  export = 'export',
}
